export default __webpack_public_path__ + "2022_AnisotropicBandEdge.pdf";